import { authAxios, createAxiosInstance } from 'common/utils/axios'

import { AI_ASSISTANT_ENDPOINTS, AI_SERVICE_URL } from 'common/constants/apiUrls'

const {
  CREATE_DOCUMENT,
  GET_DOCUMENTS,
  GET_DOCUMENT_CHUNKS,
  UPDATE_DOCUMENT,
  UPDATE_DOCUMENT_CHUNK,
  DANGEROUSLY_DELETE_DOCUMENT,
} = AI_ASSISTANT_ENDPOINTS

export const authAxiosLocalServer = createAxiosInstance(AI_SERVICE_URL)

const handler = authAxios

export const CreateDocument = async ({ title, summary, core_metadata, web_url, file }) => {
  const newForm = new FormData()
  if (file) newForm.append('file', file)
  if (title) newForm.append('title', title)
  if (summary) newForm.append('summary', summary)
  if (web_url) newForm.append('web_url', web_url)
  if (core_metadata) newForm.append('core_metadata', core_metadata)

  const response = await handler.post(CREATE_DOCUMENT, newForm, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })

  const { data } = response.data

  return data
}

export const GetDocuments = async ({ page, size, sort, document_id }) => {
  const params = {
    page: page && page,
    size: size && size,
    sort: sort && sort,
    document_id: document_id && document_id,
  }
  const response = await handler.get(GET_DOCUMENTS, { params })

  const { data } = response.data

  return data
}
export const GetDocumentChunks = async ({ page, size, sort, document_id }) => {
  const params = {
    page: page && page,
    size: size && size,
    sort: sort && sort,
  }
  const response = await handler.get(`${GET_DOCUMENT_CHUNKS}/${document_id}/chunks`, { params })

  const { data } = response.data

  return data
}

export const UpdateDocument = async ({ id, title, summary, core_metadata }) => {
  const response = await handler.patch(UPDATE_DOCUMENT, {
    id,
    title,
    summary,
    core_metadata,
  })

  const { data } = response.data

  return data
}
export const UpdateDocumentChunk = async ({ id, content, metadata, document_id }) => {
  const response = await handler.patch(`${UPDATE_DOCUMENT_CHUNK}/${document_id}/chunk`, {
    id,
    content,
    metadata,
  })

  const { data } = response.data

  return data
}

export const DeleteDocument = async ({ document_id }) => {
  const response = await handler.delete(`${DANGEROUSLY_DELETE_DOCUMENT}/${document_id}`)

  const { data } = response.data

  return data
}
